const AiChatHistory = () => {
  return <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="AiChatHistory" data-sentry-source-file="ai_chat_history.tsx">
      <rect x="1" y="1" width="20" height="14" rx="3" stroke="#86909C" strokeWidth="2" data-sentry-element="rect" data-sentry-source-file="ai_chat_history.tsx" />
      <path d="M8.25 15.5V0.5" stroke="#86909C" strokeWidth="2" data-sentry-element="path" data-sentry-source-file="ai_chat_history.tsx" />
    </svg>;
};
export default AiChatHistory;